<div style="text-align: center; padding:25px; background-color: #f2f6fa; border-radius: 6px;">
<i class="fa fa-spinner fa-pulse fa-4x"></i>
    <h3 [innerHtml]="message"></h3>
</div>
